var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource',{attrs:{"resource":"priceLevel","resourceName":"Preisstufe","attributes":[
    {
      name: 'at_amount',
      label: 'Ab Einheiten',
      type: 'Number'
    },
    {
      name: 'bonus',
      label: 'Bonus',
      type: 'Number'
    }
  ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Preisstufe erstellen")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }